import React, {
    Fragment, 
    useState
} from 'react';
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { clearNextPage } from "../redux/index";
import { useHistory } from "react-router-dom";
import { 
    Form,
    LabelledCheckboxValidated,
    Button,
    LabelledInputValidatedNyKredit,
    LabelledInputValidatedDawa
 } from "../components-shared/index";
 import { inputHelper } from "../utils/index";

const Header = styled.h1`
    width: 100%;
    font-size: 1.8rem;
    line-height: 2.5rem;
    font-weight: 400;
    margin-top: 10px;
    margin-bottom: 24px;

    ${props => props.theme.mediaQueries.medium}{
        font-size: 1.7rem;
        line-height: 2.3rem;
    }
`
 
const ContactModal = () => {
    const nextPage = useSelector(state => state.navigationReducer.nextPage);
    const [isChecked, setIsChecked] = useState(false)

    const getValue = (event) => {
        const { name, value, checked } = event.target;
        setIsChecked(checked)
    }
    
    const consent = () => {
        const consentText = {
            bookmeeting: ['Vi bruger CPR-nummer til at identificere og give dig et tilbud. Bliver du kunde, bruger vi det også til at administrere forsikringen. Ved at fortsætte accepterer du dette. Læs mere om tilbagekaldelse og hvordan vi behandler dine ', <a key="0" href="https://www.privatsikring.dk/om-privatsikring/persondatapolitik/" target="_blank">personoplysninger</a>,
            '.',
            `
            
            Hvis du ikke gennemfører booking af mødet, sletter vi dine oplysninger efter 90 dage.
            `
        ]
            ,
           
           
            uploadpolicy: [
                'Vi bruger CPR-nummer til at identificere og give dig et tilbud. Bliver du kunde, bruger vi det også til at administrere forsikringen. Ved at fortsætte accepterer du dette. Læs mere om tilbagekaldelse og hvordan vi behandler dine ', 
                <a key="0" href="https://www.privatsikring.dk/om-privatsikring/persondatapolitik/" target="_blank">personoplysninger</a>,
                '.',
                `
                
                Bemærk at hvis dine dokumenter indeholder CPR-numre på andre voksne end dig selv, så bekræfter du på deres vegne, at vi må bruge det til at give et tilbud.
                `,
                `
                Hvis du ikke gennemfører tilbudsflowet, sletter vi dine oplysninger efter 90 dage.
                `
            ]
        }

        
        const str = nextPage.match(/[^/]+$/)

        //Return to landing page on modal refresh becouse no consent text 
        //!str && useHistory().push('/')
        if (!str) {
            useHistory().push('/')
            window.location.reload();
        }

        //Use with multiple consents
        return consentText[str]
        //return consentText.bookmeeting;
    }

    return (
        <Fragment>
            <Header>
                Dine kontaktoplysninger
            </Header>

            <Form redirectTo={nextPage}>                
                <LabelledInputValidatedNyKredit
                    labelText='Navn'
                    type='text'
                    name='FullName'
                    registerRules={{
                        required: {
                            value: true,
                            message: "Skal udfyldes"
                        },
                        pattern: {
                            value: /^((?!<|>).)*$/i,
                            message: "Input indeholder ugyldige tegn"
                        }
                    }}
                />

                {/* <LabelledInputValidatedNyKredit
                    labelText='Adresse'
                    type='text'
                    name='address'
                    registerRules={{
                        required: {
                            value: true,
                            message: "This field is required"
                        },
                        pattern: {
                            value: /^((?!<|>).)*$/i,
                            message: "Input indeholder ugyldige tegn"
                        }
                    }}
                /> */}

                <LabelledInputValidatedDawa 
                    labelText='Adresse'
                    type='search'
                    name='Address'
                    registerRules={{
                        required: {
                            value: true,
                            message: "Vælg din adresse fra listen der kommer frem, når du starter med at indtaste"
                        },
                        pattern: {
                            value: /^((?!<|>).)*$/i,
                            message: "Input indeholder ugyldige tegn"
                        }
                    }}
                />

                {/* <LabelledInputValidatedNyKredit
                    labelText='Postnummer'
                    type='number'
                    pattern="[0-9]*"
                    name='PostNumber'
                    registerRules={{
                        required: {
                            value: true,
                            message: "This field is required"
                        },
                        pattern: {
                            value: /^((?!<|>).)*$/i,
                            message: "Input indeholder ugyldige tegn"
                        }
                    }}
                /> */}

                <LabelledInputValidatedNyKredit
                    labelText='Telefonnummer'
                    type='tel'
                    name='PhoneNumber'
                    //optionalFunction={handelPhonenumber}
                    registerRules={{
                        required: {
                            value: true,
                            message: "Skal udfyldes"
                        },
                        pattern: {
                            value: /^[\+]?[(]?[0-9]{2}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{2,6}$/im,

                            message: "Input indeholder ugyldige tegn"
                        }
                    }}
                />

                <LabelledInputValidatedNyKredit
                    labelText='E-mail'
                    type='email'
                    name='Email'
                    registerRules={{
                        required: {
                            value: true,
                            message: "Skal udfyldes"
                        },
                        pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/i,
                            message: "Hov. Er der mon fejl i din indtastning?"
                        }
                    }}
                />

                <LabelledInputValidatedNyKredit
                    labelText='CPR-nummer'
                    pattern="[0-9]*"
                    name='Cpr'
                    maxlength="11"
                    registerRules={{
                        required: {
                            value: true,
                            message: "Skal udfyldes"
                        },
                        pattern: {
                            value: /^(\d{6})+(-)+(\d{4})$/,
                            message: "Input indeholder ugyldige tegn, 123456-XXXX"
                        }
                    }}
                    optionalFunction={inputHelper.cprNumber.format}
                />

                <LabelledCheckboxValidated
                    name='ConcentPolicy'
                    getValue={getValue}
                    checkboxKvp={
                        [
                            {
                                labelText: consent(),
                                name: 'ConcentPolicy'
                            }
                        ]
                    }
                    registerRules={{
                        required: {
                            value: true,
                            message: "Skal udfyldes"
                        },
                        pattern: {
                            value: /(true|false)/i,
                            message: "Wrong concent"
                        }
                    }}
                />

                <Button
                    type={'submit'}
                    text={"Godkend"}
                />
            </Form>
        </Fragment>

    )
}

export default ContactModal;


